import React from "react";
import { Col, Row } from 'react-bootstrap';
import styles from './Permissions.module.css';
import PermissionSection from './PermissionSection';

export default function RolePermissionCard({ role, rolePermissions, globalScopes, teamScopes, onPermissionChange }) {
    return (
        <div className={styles.roleSection}>
            <Row className={styles.roleSectionRow}>
                <Col lg={7} className={styles.globalCol}>
                    <PermissionSection
                        titleKey="GLOBAL_PERMISSIONS"
                        scopes={globalScopes}
                        scopeType="global"
                        role={role}
                        activePermissions={rolePermissions.global}
                        onPermissionChange={onPermissionChange}
                    />
                </Col>
                <Col lg={5} className={styles.teamCol}>
                    <PermissionSection
                        titleKey="TEAMS_PERMISSIONS"
                        scopes={teamScopes}
                        scopeType="team"
                        role={role}
                        activePermissions={rolePermissions.team}
                        onPermissionChange={onPermissionChange}
                    />
                </Col>
            </Row>
        </div>
    );
}
